import { Container } from 'pixi.js';

export function areBoxesCollide(a: Container, b: Container) {
    const box1 = a.getBounds();
    const box2 = b.getBounds();

    return box1.minX <= box2.maxX && box1.maxX >= box2.minX && box1.minY <= box2.maxY && box1.maxY >= box2.minY;
}
